function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { sdkLogger } from '../../logger';
import { Observable } from '../../utils/observables/observable';
export var FULLSCREEN_EVENTS = [
    'fullscreenchange',
    'webkitfullscreenchange',
    'mozfullscreenchange',
    'msfullscreenchange'
];
export var DomPlayerFullscreenManager = /*#__PURE__*/ function() {
    "use strict";
    function DomPlayerFullscreenManager(videoElement) {
        var _this = this;
        _class_call_check(this, DomPlayerFullscreenManager);
        _define_property(this, "videoElement", void 0);
        _define_property(this, "fullscreenChanged", void 0);
        _define_property(this, "lastNotified", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "handleFullscreenChanged", void 0);
        this.videoElement = videoElement;
        this.fullscreenChanged = new Observable();
        this.lastNotified = false;
        this.logger = sdkLogger.withContext('Dom Player Fullscreen Manager');
        this.handleFullscreenChanged = function(e) {
            var targetElement = e.target;
            var isVideoElement = targetElement === _this.videoElement;
            // If the video element is fullscreen we know we can notify true.
            // This scenario is unlikely since the clients will probably make
            // the container div fullscreen to preserve custom controls UI
            if (isVideoElement && document.fullscreenElement === targetElement) {
                _this.logger.info('Video Fullscreen Event: ', true);
                _this.lastNotified = true;
                _this.fullscreenChanged.notifyObservers(true);
                return;
            }
            var isVideoElementFullscreen = _this.checkIsVideoElementFullscreen();
            if (isVideoElementFullscreen !== _this.lastNotified) {
                _this.logger.info('Video Fullscreen Event: ', isVideoElementFullscreen);
                _this.lastNotified = isVideoElementFullscreen;
                _this.fullscreenChanged.notifyObservers(isVideoElementFullscreen);
                return;
            }
        };
        FULLSCREEN_EVENTS.forEach(function(eventType) {
            document.addEventListener(eventType, _this.handleFullscreenChanged);
        });
    }
    _create_class(DomPlayerFullscreenManager, [
        {
            key: "onFullscreenChanged",
            value: function onFullscreenChanged(handler) {
                this.fullscreenChanged.registerObserver(handler, this);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this = this;
                this.fullscreenChanged.unregisterObservers(this);
                FULLSCREEN_EVENTS.forEach(function(eventType) {
                    document.removeEventListener(eventType, _this.handleFullscreenChanged);
                });
            }
        },
        {
            key: "checkIsVideoElementFullscreen",
            value: function checkIsVideoElementFullscreen() {
                // If the video is 95% of the window size treat it as fullscreen
                // this will account for padding on the container element if it exists
                var tolerancePercent = 0.95;
                var innerWidth = self.innerWidth * tolerancePercent;
                var innerHeight = self.innerHeight * tolerancePercent;
                var _this_videoElement_getBoundingClientRect = this.videoElement.getBoundingClientRect(), videoWidth = _this_videoElement_getBoundingClientRect.width, videoHeight = _this_videoElement_getBoundingClientRect.height;
                return videoWidth >= innerWidth || videoHeight >= innerHeight;
            }
        }
    ]);
    return DomPlayerFullscreenManager;
}();

//# sourceMappingURL=dom-player-fullscreen-manager.js.map